export default __webpack_public_path__ + "6142db8e5e111d543a18835c01da65f2.svg";